"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "UnstableContext", {
  enumerable: true,
  get: function get() {
    return _context.UnstableContext;
  }
});
exports.default = void 0;
var _Slider = _interopRequireDefault(require("./Slider"));
var _context = require("./context");
var _default = exports.default = _Slider.default;